// Resolves once the page has loaded and the browser is next idle: when to
// fetch what the visitor has not come to yet, so it never competes with what
// they came to see. For the browser only.
let settled = null;
export default function pageSettled() {
  if (!settled) {
    settled = new Promise((resolve) => {
      if (document.readyState === "complete") resolve();
      else window.addEventListener("load", () => resolve(), { once: true });
    }).then(() => new Promise((resolve) => (window.requestIdleCallback ? window.requestIdleCallback(resolve, { timeout: 2000 }) : setTimeout(resolve, 0))));
  }
  return settled;
}
